<template>
  <v-app id="inspire" class="page">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-card class="elevation-12 my-5 pt-5 pb-10 px-0 card-theme agent_card">
            <v-card-text>
              <v-alert
                :value="true"
                color="#19A99D"
                style="color: white; border-radius: 1rem; padding: 21px 28px;"
                class="alert-login-vendor mt-4"
              >
                <strong>
                  <h1 class="text-center mt-12">No Access</h1>
                </strong>
              </v-alert>
            </v-card-text>

            <p class="text_fin_content">
              Already have an account?
              <a
                @click="onClickProfileMenu()"
                class="login-class no-decoration iink_login"
              >Login</a>
            </p>
            <div class="sombra"></div>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Login",
  computed: {
    ...mapState({
      user: state => state.Authenticate.user
    })
  },
  data: () => ({
    //
    image: require("@/assets/logo.svg"),
    drawer: false
  }),
  components: {},
  methods: {
    onClickProfileMenu() {
      this.$store.dispatch("Authenticate/logout");
      this.$store.dispatch("Banner/hide");
      this.$router.push("/login");
    }
  }
};
</script>


<style scoped>
/* estilo para pregunta */
.agent_card {
  max-width: 788px !important;
  width: 788px !important;
  min-height: 699px !important;
}

.iink_login {
  margin-left: 8px;
}

.azul {
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.31px;
  margin-right: 11px;
}

/* estilo para h1 */
.azul-header {
  color: #041332;
  font-size: 25px;
  font-weight: 700;
  line-height: 34px;
}

/* estilo para link ContactUs*/
.azul-contact {
  font-size: 15px;
  font-weight: 700;
}

/* estilo para texto debajo de login */
.v-application .py-2 {
  color: #878787;
  font-size: 15px;
  font-weight: 500;
}

.btn-t {
  width: 155px;
  height: 48px;
  color: white;
  box-shadow: 0 5px 18px rgba(51, 51, 51, 0.13);
  border-radius: 24px;
}

.ui-label {
  color: #061d47;
  /*!important;*/
  font-size: 20px !important;
  font-weight: bold !important;
}

.padd-log {
  padding: 0 98px;
}

.card-theme {
  -webkit-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
  -moz-box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 20px 15px -15px rgba(0, 0, 0, 0.1) !important;
}

.v-input__control {
  width: 34px;
}

.fa-theme--a {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #29abe2;
  font-size: 10px !important;
}

.alert-login-vendor h3 {
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
}

.alert-login-vendor p {
  font-size: 17px;
  font-weight: 400;
  letter-spacing: -0.33px;
  line-height: 18px;
}

.alert-login-vendor {
  max-width: 675px !important;
  height: 265px !important;
  margin: 0 auto;
}

.title_aggent {
  color: #041332;
  font-size: 30px;
  font-weight: 500;
  line-height: 34px;
  margin-left: 28px;
  font-family: "Roboto-Medium" !important;
  margin-top: 18px;
}

.text_fin_content {
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.31px;
  line-height: 27px;
  margin-top: 47px;
  margin-left: 289px;
}

@media (max-width: 1200px) {
  .alert-login-vendor {
    width: 100% !important;
    height: auto !important;
  }

  .text_fin_content {
    margin-left: 0;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .v-application .px-10 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .padd-log {
    padding: 0;
  }
}
</style>
